import React, { FC, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Redirect } from "react-router"
import { userLogout } from "../../../../Actions/Auth/AuthActions"
import { getEmail } from "../../../../Helpers/Functions/Selectors/auth"
import { useAppState } from "../../../../Hooks/useReduxState"
import { AuthFormView } from "../../../../Models/Client/AuthFormView"
import { Invitation } from "../../../../Models/Client/Invitation"
import { MainThunkDispatch, MainThunkResult } from "../../../../Reducers"
import { Loader } from "dash-styled"
import { Auth } from "../../Auth/Auth"

interface InvitationAcceptProps {
    invitation: Invitation
    email: string | undefined
    acceptAction: MainThunkResult<Promise<unknown>>
    redirectRouteOnComplete: string
}

type MemberSignupStage = "checking-auth" | "signing-in" | "accepting" | "done"

export const InvitationAccept: FC<InvitationAcceptProps> = ({
    invitation,
    email,
    acceptAction,
    redirectRouteOnComplete
}) => {
    const [stage, setStage] = useState<MemberSignupStage>("checking-auth")
    const dispatch = useDispatch<MainThunkDispatch>()
    const loggedInEmail = useAppState(getEmail)
    const shouldLogout =
        email !== undefined &&
        loggedInEmail !== undefined &&
        loggedInEmail !== email

    useEffect(() => {
        if (shouldLogout) {
            dispatch(userLogout(true))
        }
    }, [dispatch, shouldLogout])

    useEffect(() => {
        if (stage !== "accepting" || shouldLogout) {
            return
        }

        dispatch(acceptAction).then(() => setStage("done"))
    }, [acceptAction, dispatch, shouldLogout, stage])

    useEffect(() => {
        if (
            (stage === "checking-auth" || stage === "signing-in") &&
            email !== undefined &&
            !shouldLogout
        ) {
            setStage(loggedInEmail === undefined ? "signing-in" : "accepting")
        }
    }, [email, loggedInEmail, shouldLogout, stage])

    if (stage === "checking-auth" || stage === "accepting") {
        return <Loader />
    }

    if (stage === "done") {
        return <Redirect to={redirectRouteOnComplete} />
    }

    return (
        <Auth
            type={AuthFormView.login}
            squashSuccessMessage={true}
            invitation={invitation}
        />
    )
}
